module.exports = __webpack_public_path__ + "assets/img/CONTROLDECALIDAD.cc3a48d1.svg";